// RTR MV
export const DEFAULT_ANIMATION_AT_LANDING = 'top-left';
export const DEFAULT_APPLICATIVE_ZOOM = '100';
export const DEFAULT_BACKGROUND = undefined;
// Custom
export const DEFAULT_AUTOMATIC_FRAMING_COMPONENT = true;
export const DEFAULT_HIGHLIGHT_COMPONENT = true;
export const DEFAULT_DISPLAY_COMPONENT_POINTER = true;
export const DEFAULT_BLUR_VISIBILITY = true;
export const DEFAULT_BUTTON_OVERLAY_OVERVIEW_TIME = 4 * 1000; // milliseconds
export const DEFAULT_BUTTONS_VISIBILITY = {
    accessibility: 'visible',
    displayOverlay: 'visible',
    explosion: 'visible',
    tutorial: 'visible',
};
export const DEFAULT_CALLBACK = () => { };
export const DEFAULT_EMBEDDED_OVERVIEW_TIME = 3 * 1000; // milliseconds
export const DEFAULT_LABELS_DELAY = 0; // milliseconds
export const DEFAULT_ORBIT_POINT = true;
export const DEFAULT_OVERLAY_SELECTOR = 'rtr-overlay-container';
export const DEFAULT_OVERLAY_FULLSCREEN = false;
export const DEFAULT_OVERVIEW_VISIBILITY = true;
export const DEFAULT_SHOW_TRANSITIONS_SLIDER = true;
export const DEFAULT_TRANSMISSION_CLEAR_ALPHA = 0.5;
export const DEFAULT_TRANSMISSION_CLEAR_COLOR = '#ffffff';
export const DEFAULT_TRANSPARENT = false;
// RTR
export const DEFAULT_RTR_SETTINGS_AUTO_RESET_CAMERA = false;
export const DEFAULT_RTR_SETTINGS_BACKGROUND_FIT = 'fill';
export const DEFAULT_RTR_SETTINGS_BOUNDING_AREA = {
    topLeft: {
        x: 0,
        y: 0,
    },
    bottomRight: {
        x: 1,
        y: 1,
    },
};
export const DEFAULT_RTR_SETTINGS_BOUNDING_FIT = 'auto';
export const DEFAULT_RTR_SETTINGS_CAMERA_ANIMATION_TIME = 0.3;
export const DEFAULT_RTR_SETTINGS_CAMERA_ROTATION_INITIAL = {
    phi: 0,
    theta: 0,
};
export const DEFAULT_RTR_SETTINGS_CAMERA_ROTATION_RESET = {
    phi: 20,
    theta: 30,
};
export const DEFAULT_RTR_SETTINGS_LENSES_OPACITY = 0.5;
export const DEFAULT_RTR_SETTINGS_SELECTOR = '#rtr-viewer-container';
